module.exports = __webpack_public_path__ + "img/1.eaaf07d8.jpg";